var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconModalError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 49.7812C14.4183 49.7812 4.21875 39.5817 4.21875 27C4.21875 14.4183 14.4183 4.21875 27 4.21875C39.5817 4.21875 49.7812 14.4183 49.7812 27C49.7812 39.5817 39.5817 49.7812 27 49.7812Z",
    fill: "#FFD8E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0976 17.4981C24.0443 16.1345 25.1354 15 26.5 15C27.8646 15 28.9557 16.1345 28.9024 17.4981L28.4482 29.1264C28.4073 30.1728 27.5472 31 26.5 31C25.4528 31 24.5927 30.1728 24.5518 29.1264L24.0976 17.4981Z",
    fill: "#FF3969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4905 39C25.1027 39 24 37.9147 24 36.5C24 35.0853 25.1027 34 26.4905 34C27.9163 34 29 35.0853 29 36.5C29 37.9147 27.9163 39 26.4905 39Z",
    fill: "#FF3969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalError);
export default __webpack_public_path__ + "static/media/icon_modal_error.e670ad19fc46e704d73884d10d092aa1.svg";
export { ForwardRef as ReactComponent };